module.exports = __webpack_public_path__ + "img/order4.6e8ad9ff.svg";